import { useRef } from 'react';

import {
  SALONS_ALPHA_BOOKING_FLAG,
  useIsCategoryFirstEnabled,
} from '@/hooks/flags/useIsCategoryFirstEnabled';
import { useIsLaunchDarklyFlagResolved } from '@/hooks/flags/useLaunchDarklyFlag';

import type { LatchedCategoryFirstShop } from './types';

/**
 * Whether category-first is on, or `null` until LaunchDarkly has resolved (a
 * cold deep link would otherwise read the `false` default) and `shop` is
 * loaded (its brand setting would otherwise read as off).
 *
 * The first resolved value is kept for the life of the component: a redirect
 * fired after a screen is already showing would be turned into a goBack by
 * `useUnfocusCallback`, throwing the user out of the flow.
 */
export function useLatchedCategoryFirstDecision(
  shop: LatchedCategoryFirstShop | undefined,
): boolean | null {
  const isCategoryFirstEnabled = useIsCategoryFirstEnabled(shop ?? {});
  const isFlagResolved = useIsLaunchDarklyFlagResolved(
    SALONS_ALPHA_BOOKING_FLAG,
  );
  const decisionRef = useRef<boolean | null>(null);
  if (decisionRef.current === null && shop && isFlagResolved) {
    decisionRef.current = isCategoryFirstEnabled;
  }

  return decisionRef.current;
}
